import * as v from 'valibot'
import { response, type ApiType } from '../../../shared/schemas'
import type { ApiAnswerFeaturesDto, FeaturesDto } from './features.h'

export const FeaturesSchema = v.object({
  appearanceCustomizationEnabled: v.optional(v.boolean()),
  countryLocation: v.optional(
    v.object({ country: v.optional(v.string(), 'US') })
  ),
  facebookLoginEnabled: v.optional(v.boolean()),
  guestModeEnabled: v.optional(v.boolean()),
  inAppCredentialsChangeEnabled: v.optional(v.boolean()),
  partnersProgramEnabled: v.optional(v.boolean()),
  registrationEnabled: v.optional(v.boolean()),
  resetPasswordEnabled: v.optional(v.boolean()),
  signInByQrCodeEnabled: v.optional(v.boolean()),
  signInWithPhoneEnabled: v.optional(v.boolean()),
  singInWithAppleEnabled: v.optional(v.boolean()),
}) satisfies ApiType<FeaturesDto, any>

// /api/v3/features
export const FeaturesResponseSchema = response(
  FeaturesSchema
) satisfies ApiType<ApiAnswerFeaturesDto, any>
